import { createAction } from "@reduxjs/toolkit";

interface APICall {
  url: string;
  method: string;
  headers?: Record<string, string>; // Add headers property
  data?: any;
  onSuccess?: any;
  onError?: any;
  resolve?: Function;
  reject?: Function;
}

export const apiCallBegan = createAction<APICall>("api/callBegan");
export const apiCallSuccess = createAction("api/callSuccess");
export const apiCallError = createAction("api/callError");
